import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { Location } from '@angular/common';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { ButtonComponent } from 'htx-ui-library';

@Component({
  selector: 'app-imprint-page',
  standalone: true,
  imports: [TranslocoDirective, TranslocoPipe, ButtonComponent],
  templateUrl: './imprint-page.component.html',
  styleUrl: './imprint-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImprintPageComponent {
  private location = inject(Location);

  goBack(): void {
    this.location.back();
  }
}
